import { createSlotRecipe } from './runtime';

const segmentGroupConfig = {"name":"segmentGroup","slots":["root","label","item","itemText","itemControl","indicator"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const segmentGroup = /* @__PURE__ */ createSlotRecipe(segmentGroupConfig)